import React, {Component} from "react";
import {Radio, Row} from "antd";
import FieldError from "../../../../components/common/input/FieldError";
import {MODE_BRING, MODE_DONT_BRING, MODE_IDK, TYPE_IDK, TYPE_TIRES, TYPE_WHEELS} from "../../definition/business";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";

class TireExchange extends Component {

  onSelectTireExchangeModeClosure = mode => () => {
    this.props.setTireExchange({mode})
  };

  onSelectTireExchangeTypeClosure = type => () => {
    this.props.setTireExchange({type})
  };

  render() {
    const {intl: {formatMessage}, tiresExchange={}} = this.props;

    return <div style={{marginLeft: '3rem'}}>
      <Row>
        <p>
          {formatMessage({id: 'customer.journey.step.serviceMobility.tireExchange.typeTitle'})}
        </p>
          {!tiresExchange.type && (

            <FieldError error={{message: 'error.min.one.checked'}}/>
          )}
      </Row>
      <div style={{marginLeft: 20}}>
        <Row>
          <Radio
            checked={tiresExchange.type === TYPE_WHEELS}
            onClick={this.onSelectTireExchangeTypeClosure(TYPE_WHEELS)}
          >
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireExchange.typeWheels'})}
          </Radio>
        </Row>
        <Row>
          <Radio
            checked={tiresExchange.type === TYPE_TIRES}
            onClick={this.onSelectTireExchangeTypeClosure(TYPE_TIRES)}
          >
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireExchange.typeTires'})}
          </Radio>
        </Row>
        <Row>
          <Radio
            checked={tiresExchange.type === TYPE_IDK}
            onClick={this.onSelectTireExchangeTypeClosure(TYPE_IDK)}
          >
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireExchange.typeIdk'})}
          </Radio>
        </Row>
      </div>
      <Row>
        <p>
          {formatMessage({id: 'customer.journey.step.serviceMobility.tireExchange.modeTitle'})}
        </p>
          {!tiresExchange.mode && (
            <FieldError error={{message: 'error.min.one.checked'}}/>
          )}

      </Row>
      <div style={{marginLeft: 20}}>
        <Row>
          <Radio
            checked={tiresExchange.mode === MODE_BRING}
            onClick={this.onSelectTireExchangeModeClosure(MODE_BRING)}
          >
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireExchange.modeYes'})}
          </Radio>
        </Row>
        <Row>
          <Radio
            checked={tiresExchange.mode === MODE_DONT_BRING}
            onClick={this.onSelectTireExchangeModeClosure(MODE_DONT_BRING)}
          >
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireExchange.modeNo'})}
          </Radio>
        </Row>
        <Row>
          <Radio
            checked={tiresExchange.mode === MODE_IDK}
            onClick={this.onSelectTireExchangeModeClosure(MODE_IDK)}
          >
            {formatMessage({id: 'customer.journey.step.serviceMobility.tireExchange.modeIdk'})}
          </Radio>
        </Row>
      </div>
    </div>
  }
}

const mapDispatchToProps = dispatch => ({
  setTireExchange: params => dispatch({ type: 'SAVE.TIRE_EXCHANGE', params }),
});

const mapStateToProps = state => ({
  tiresExchange: state.createAppointmentRequest.tiresExchange,

});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TireExchange)
);

